// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__2CPyk","center":"Table_center__HHfJh","right":"Table_right__3wovl","fill":"Table_fill__1EBxQ","footerHeader":"Table_footerHeader__2jIpp"};